import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=0bd6b122"
import script from "./indexPage.vue?vue&type=script&lang=js"
export * from "./indexPage.vue?vue&type=script&lang=js"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=0bd6b122&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports